module.exports = __webpack_public_path__ + "img/rightside_300.55910732.png";